// 体育竞猜特有的颜色常量
export const SPORT_YES_BG_COLOR = "#30A15919"; // yes 背景色（带透明度）
export const SPORT_YES_TEXT_COLOR = "#30a159"; // yes 文字颜色
export const SPORT_YES_SPLIT_COLOR = "#30a15966"; // yes 边框颜色, 40% opacity
export const SPORT_NO_BG_COLOR = "#E2393919"; // no 背景色（带透明度）
export const SPORT_NO_TEXT_COLOR = "#e23939"; // no 文字颜色
export const SPORT_NO_SPLIT_COLOR = "#e2393966"; // no 边框颜色, 40% opacity
